import React, { useEffect } from 'react';
import Avatar from './Avatar';

// Das Panel faehrt von rechts herein. Es bleibt immer im DOM, damit die
// Transform-Animation auch beim Schliessen laeuft.
const PlayerDetail = ({ detail, onClose }) => {
  useEffect(() => {
    if (!detail) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [detail, onClose]);

  return (
    <>
      {detail && (
        <div
          onClick={onClose}
          style={{ position: 'fixed', inset: 0, zIndex: 20, background: 'rgba(24,38,22,.28)' }}
        />
      )}

      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          width: 420,
          maxWidth: '92vw',
          zIndex: 21,
          background: '#fff',
          borderLeft: '1px solid #e4ece0',
          boxShadow: '-24px 0 60px -40px rgba(20,45,20,.7)',
          overflow: 'auto',
          transition: 'transform .28s cubic-bezier(.3,.8,.3,1)',
          transform: detail ? 'translateX(0)' : 'translateX(105%)',
        }}
      >
        {detail && (
          <div style={{ padding: '30px 30px 40px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 22,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <Avatar src={detail.imgUrl} initials={detail.initials} size={52} font={17} />
                <div>
                  <div style={{ fontSize: 20, fontWeight: 650 }}>{detail.name}</div>
                  <div style={{ fontSize: 13, color: '#778574' }}>{detail.subtitle}</div>
                </div>
              </div>
              <div
                onClick={onClose}
                className="otter-close"
                style={{
                  cursor: 'pointer',
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  display: 'grid',
                  placeItems: 'center',
                  color: '#6f7d6c',
                  fontSize: 18,
                }}
              >
                &times;
              </div>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: 10,
                marginBottom: 26,
              }}
            >
              {detail.tiles.map((t) => (
                <div
                  key={t.label}
                  style={{
                    background: '#f6faf3',
                    border: '1px solid #eaf1e4',
                    borderRadius: 12,
                    padding: '12px 13px',
                  }}
                >
                  <div
                    style={{
                      fontSize: 11,
                      letterSpacing: '.06em',
                      textTransform: 'uppercase',
                      color: '#8b978a',
                    }}
                  >
                    {t.label}
                  </div>
                  <div
                    style={{
                      fontSize: 21,
                      fontWeight: 650,
                      marginTop: 4,
                      fontVariantNumeric: 'tabular-nums',
                    }}
                  >
                    {t.value}
                  </div>
                </div>
              ))}
            </div>

            <div
              style={{
                fontSize: 12,
                letterSpacing: '.08em',
                textTransform: 'uppercase',
                color: '#8b978a',
                marginBottom: 12,
              }}
            >
              Versus clan average
            </div>
            <div
              style={{ display: 'flex', flexDirection: 'column', gap: 14, marginBottom: 26 }}
            >
              {detail.bars.map((b) => (
                <div key={b.label}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontSize: 13,
                      marginBottom: 6,
                    }}
                  >
                    <span>{b.label}</span>
                    <span style={b.deltaStyle}>{b.delta}</span>
                  </div>
                  <div
                    style={{
                      position: 'relative',
                      height: 10,
                      borderRadius: 99,
                      background: '#f0f4ec',
                    }}
                  >
                    <div style={b.fill} />
                    <div
                      style={{
                        position: 'absolute',
                        top: -3,
                        bottom: -3,
                        width: 2,
                        background: '#b9c6b4',
                        left: '50%',
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div
              style={{
                fontSize: 12,
                letterSpacing: '.08em',
                textTransform: 'uppercase',
                color: '#8b978a',
                marginBottom: 10,
              }}
            >
              Notes
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {detail.notes.map((n) => (
                <div
                  key={n}
                  style={{
                    fontSize: 13.5,
                    color: '#4e5c4c',
                    background: '#f6faf3',
                    borderRadius: 10,
                    padding: '10px 12px',
                  }}
                >
                  {n}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PlayerDetail;
